import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useEffectiveRole, EffectiveRole } from '@/hooks/useEffectiveRole';
import { Loader2 } from 'lucide-react';

interface RoleGateProps {
  children: ReactNode;
  /** Roles allowed to access this content */
  allowed: EffectiveRole[];
  /** Where to redirect if not allowed (default: /app) */
  fallback?: string;
}

/**
 * Wraps content that should only be visible to specific roles.
 * Redirects unauthorized users to /app.
 */
export function RoleGate({ children, allowed, fallback = '/app' }: RoleGateProps) {
  const { effectiveRole, loading } = useEffectiveRole();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!allowed.includes(effectiveRole)) {
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
